import {
	UTM_COOKIE_NAME,
	UTM_SESSION_KEY,
	whenAnalyticsAllowed,
} from '@/utils/use-cookie-consent';
// @ts-expect-error this is the correct way to import https://vueuse.org/integrations/useCookies/
import { useCookies } from '@vueuse/integrations/useCookies';

/**
 * UTM tags of the landing URL, kept in sessionStorage (tab-scoped) until the
 * attribution cookie may be written, so a reload or hard link during the same
 * visit still attributes a sign-up.
 */
function readSessionTags(): Record<string, string> | undefined {
	try {
		const raw = window.sessionStorage.getItem(UTM_SESSION_KEY);
		return raw ? (JSON.parse(raw) as Record<string, string>) : undefined;
	} catch {
		return undefined;
	}
}

function writeSessionTags(tags: Record<string, string>) {
	try {
		window.sessionStorage.setItem(UTM_SESSION_KEY, JSON.stringify(tags));
	} catch {
		// storage unavailable: attribution then relies on the cookie only
	}
}

export function useUtmTags() {
	if (!window?.location) {
		return;
	}
	const url = new URL(window.location.href);
	const { get, set } = useCookies();
	const params = Object.fromEntries(new URLSearchParams(url.search)) as Record<
		string,
		string
	>;
	const utmTags = (Object.keys(params) ?? [])
		.filter((k) => k.toLowerCase().startsWith('utm'))
		.reduce<Record<string, string>>((acc, k) => {
			acc[k] = params[k] ?? '';
			return acc;
		}, {});

	if (Object.keys(utmTags).length > 0) {
		writeSessionTags(utmTags);
		// Attribution cookie: written only with analytics consent (cookie banner).
		whenAnalyticsAllowed(() => set(UTM_COOKIE_NAME, utmTags), UTM_COOKIE_NAME);
	}

	return {
		getUtmTags: () => get(UTM_COOKIE_NAME) ?? readSessionTags(),
	};
}
